import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Vibration from '@/views/Vibration'
import Flash from '@/views/Flash'
import Camera from '@/views/Camera'
import Nfc from '@/views/Nfc'
import Localisation from '@/views/Localisation'

import Colmenares from '@/views/colmenares/Colmenares'
import ColmenarEditar from '@/views/colmenares/ColmenarEditar'
import ColmenarNuevo from '@/views/colmenares/ColmenarNuevo'
import Colmenar from '@/views/colmenares/Colmenar'

import Colmena from '@/views/colmena/ColmenaDetail'
import ColmenaNueva from '@/views/colmena/ColmenaNueva'
import ColmenaEditar from '@/views/colmena/ColmenaEditar'


import HiveMini from '@/views/hive_mini/HiveMini'
import HiveMiniNew from '@/views/hive_mini/HiveMiniNew'
import HiveMiniEdit from '@/views/hive_mini/HiveMiniEdit'
import HiveMiniStateNew from '@/views/hive_mini/HiveMiniStateNew'


/*import Visitas from '@/views/VisitasColmenar'
import VisitasNueva from '@/views/VisitasNueva'
*/

import HiveVisitsNew from '@/views/hive_visits/HiveVisitsNew'
import HiveVisitsEdit from '@/views/hive_visits/HiveVisitsEdit'

import Queens from '@/views/queens/Queens'
import QueenDetail from '@/views/queens/QueenDetail'
import QueenNew from '@/views/queens/QueenNew'
import QueenEdit from '@/views/queens/QueenEdit'

import QueenCycles from '@/views/queens_cycle/QueenCycles'
import QueenCycleNew from '@/views/queens_cycle/QueenCycleNew'
import QueenCycleEdit from '@/views/queens_cycle/QueenCycleEdit'

import Tasks from '@/views/task/Tasks'
import TasksHive from '@/views/task/TasksHive'
import TaskNew from '@/views/task/TaskNew'
import TaskNewVisit from '@/views/task/TaskNewVisit'
import TaskEdit from '@/views/task/TaskEdit'

import VarroaNewVisit from '@/views/varroa/VarroaNewVisit'
import VarroaEdit from '@/views/varroa/VarroaEdit'

import FeedNew from '@/views/hive_feed/FeedNew'
import FeedEdit from '@/views/hive_feed/FeedEdit'

import Login from '@/views/login/login'


Vue.use(Router);





export default new Router({

scrollBehavior (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
},

  routes: [
    {
          path: '/login',
          name: 'Login',
          component: Login
        },{

      path: '/',
      name: 'Home',
      component: Home
    },{
      path: '/vibration',
      name: 'Vibration',
      component: Vibration
    },{
      path: '/flash',
      name: 'Flash',
      component: Flash
    },{
      path: '/camera',
      name: 'Camera',
      component: Camera
    },{
      path: '/nfc',
      name: 'Nfc',
      component: Nfc
    },{
       path: '/colmenares',
       name: 'Colmenares',
       component: Colmenares
    },{
       path: '/colmenar-nuevo',
       name: 'ColmenarNuevo',
       component: ColmenarNuevo
    },{
       path: '/colmenar-editar/:id',
       name: 'ColmenarEditar',
       component: ColmenarEditar
    },{
       path: '/colmenar/:id',
       name: 'Colmenar',
       component: Colmenar
    },{
       path: '/colmena/:id',
       name: 'Colmena',
       component: Colmena
     },{
      path: '/colmena-nueva/:id',
      name: 'ColmenaNueva',
      component: ColmenaNueva
     },{
      path: '/colmena-editar/:id',
      name: 'ColmenaEditar',
      component: ColmenaEditar
    },{

      path: '/colmenas-mini',
      name: 'HiveMini',
      component: HiveMini
    },{
      path: '/colmena-mini-editar/:id',
      name: 'HiveMiniEdit',
      component: HiveMiniEdit
     },{
      path: '/colmena-mini-nueva',
      name: 'HiveMiniNew',
      component: HiveMiniNew
     },{
       path: '/colmena-mini-estado-nuevo/:id',
       name: 'HiveMiniStateNew',
       component: HiveMiniStateNew
      },{
      path: '/localisation',
      name: 'Localisation',
      component: Localisation
 /*   },{
      path: '/nueva-visita/:id',
      name: 'VisitasNueva',
      component: VisitasNueva
    },{
      path: '/visitas-colmenar/:id',
      name: 'VisitasColmenar',
      component: Visitas
    },{
      path: '/nueva-colmena/:id',
      name: 'NuevaColmena',
      component: NuevaColmena
      */


  },{
        path: '/visita-colmena-nueva/:id',
        name: 'HiveVisitsNew',
        component: HiveVisitsNew
       },{
        path: '/visita-colmena-editar/:id',
        name: 'HiveVisitsEdit',
        component: HiveVisitsEdit

    },{
      path: '/Queens',
      name: 'Queens',
      component: Queens
    },{
      path: '/queen-detalle/:id',
      name: 'QueenDetail',
      component: QueenDetail
     },{
      path: '/queen-editar/:id',
      name: 'QueenEdit',
      component: QueenEdit
     },{
      path: '/queen-nueva',
      name: 'QueenNew',
      component: QueenNew
    },{
      path: '/ciclos-reina/:id',
      name: 'QueenCycles',
      component: QueenCycles
    },{
      path: '/ciclo-reina-editar/:id',
      name: 'QueenCycleEdit',
      component: QueenCycleEdit
     },{
      path: '/ciclo-reina-nueva/:id',
      name: 'QueenCycleNew',
      component: QueenCycleNew
    },{
      path: '/Tareas',
      name: 'Tasks',
      component: Tasks
    },{
       path: '/tareas-colmena/:id',
       name: 'TasksHive',
       component: TasksHive
    },{
      path: '/tarea-editar/:id',
      name: 'TaskEdit',
      component: TaskEdit
    },{
      path: '/tarea-nueva',
      name: 'TaskNew',
      component: TaskNew
    },{
      path: '/tarea-nueva-visita/:idcolmenar/:idcolmena',
      name: 'TaskNewVisit',
      component: TaskNewVisit
    },{
      path: '/varroa-nueva-visita/:idcolmena',
      name: 'VarroaNewVisit',
      component: VarroaNewVisit
    },{
      path: '/varroa-editar/:id',
      name: 'VarroaEdit',
      component: VarroaEdit
    },{
      path: '/alimentar-colmenar/:idcolmenar',
      name: 'FeedNew',
      component: FeedNew
    },{
      path: '/alimentar-colmenar-editar/:id',
      name: 'FeedEdit',
      component: FeedEdit
    }
  ],




})